import { useSnackbar } from "notistack";
import { UnlockCategoryUseCase } from "../../../../../domain/usecase/category/unlock/UseCase";
import { CategoryUnlockCode, UnlockCategoryRequestModel } from "../../../../../domain/model/Category";
import { State } from "../../../../../domain/model/ResponseState";
import { showGlobalLoadingView } from "../../../../../core/utils/Utils";
import { useState } from "react";

export function UnlockCategoryViewModel(
  unlockCategoryUseCase: UnlockCategoryUseCase
) {
  const { enqueueSnackbar } = useSnackbar();

  const [isUnlocked, setIsUnlocked] = useState(false);
  const [generatedUnlockCodes, setGeneratedUnlockCodes] = useState<Array<CategoryUnlockCode>>([]);

  async function unlockCategory(
    model: UnlockCategoryRequestModel
  ): Promise<boolean> {
    showGlobalLoadingView(true);
    const response = await unlockCategoryUseCase.invoke(model);
    showGlobalLoadingView(false);
    switch (response.responseState) {
      case State.Success:
        if (response.data) {
          setGeneratedUnlockCodes(response.data);
          setIsUnlocked(true);
          return true;
        } else {
          return false;
        }
      case State.Fail:
      case State.Error:
        showSnackbar(response.error?.message);
        break;
    }
    return false;
  }

  function showSnackbar(
    message: string | undefined,
    variant: "error" | "success" = "error"
  ) {
    if (message) enqueueSnackbar(message, { variant: variant });
  }

  return { showSnackbar, unlockCategory, isUnlocked, generatedUnlockCodes };
}
